import { FunctionComponent } from 'react'

import StyledButton from '../StyledButton'
import ButtonIcon from '../ButtonIcon'

export interface PlayButtonProps {
  smallSize?: boolean
  isOverlay?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const PlayButton: FunctionComponent<PlayButtonProps> = ({
  smallSize,
  isOverlay,
  onClick,
}) => {
  return (
    <StyledButton onClick={onClick}>
      <ButtonIcon
        iconName="video-play"
        smallSize={smallSize}
        isOverlay={isOverlay}
      />
    </StyledButton>
  )
}

export default PlayButton
